// src/web-app/lib/config.js
// Web app configuration - always uses Cloud Run API

// Cloud Run URL for production
export const CLOUD_RUN_URL = "https://pelaikan-api-772587166095.europe-west9.run.app";

// For authentication: always use Cloud Run
export const AUTH_API_URL = CLOUD_RUN_URL;

// For backwards compatibility
export const BASE_API_URL = AUTH_API_URL;

export const firebaseConfig = {
  apiKey:        "AIzaSyCO_SNK4hGIt2SUVm6yJ2UMqRTjiVxXwLo",
  authDomain:    "pelaikan-app.firebaseapp.com",
  projectId:     "pelaikan-app",
  appId:         "1:772587166095:web:826c89e1d2e5355bdbd3fa",
  storageBucket: "pelaikan-app.firebasestorage.app",
  messagingSenderId: "772587166095",
};






